import { Model } from "appworks/model/model";
import { SettingsModel } from "appworks/model/settings/settings-model";
import { Services } from "appworks/services/services";
import { stateMachine } from "appworks/state-machine/state-machine";
import { Service } from "../service";

export class Settings extends Service {

    private static SPACE_TO_SPIN: string = "spaceToSpin";
    private static DISPLAY_CREDITS: string = "displayCredits";
    private static SHOW_INTRO: string = "showIntro";
    private static QUICK_SPIN: string = "quickSpin";

    public saveSettings: boolean = true;

    private settingsModel: SettingsModel;

    public init(): void {
        Model.onUpdate.add(() => {
            this.settingsModel = Model.read().settings;

            this.save();
            this.updateTurbo();
        });
    }

    public quickSpinEnabled() {
        return this.settingsModel.quickSpin;
    }

    public turboEnabled() {
        return this.settingsModel.turboSpin;
    }

    public load() {

        const displayCredits = Services.storage.getBoolean(Settings.DISPLAY_CREDITS);
        const showIntro = Services.storage.getBoolean(Settings.SHOW_INTRO);
        const spaceToSpin = Services.storage.getBoolean(Settings.SPACE_TO_SPIN);
        const quickSpin = Services.storage.getBoolean(Settings.QUICK_SPIN);

        const settings: Partial<SettingsModel> = {};
        if (spaceToSpin !== null) {
            settings.spaceToSpin = spaceToSpin;
        }
        if (displayCredits !== null) {
            settings.displayCredits = displayCredits;
        }
        if (showIntro !== null) {
            settings.showIntro = showIntro;
        }
        if (quickSpin !== null) {
            settings.quickSpin = quickSpin;
        }

        Model.write({
            settings
        });
    }

    private save() {
        if (this.saveSettings) {
            Services.storage.set(Settings.DISPLAY_CREDITS, this.settingsModel.displayCredits);
            Services.storage.set(Settings.SHOW_INTRO, this.settingsModel.showIntro);
            Services.storage.set(Settings.SPACE_TO_SPIN, this.settingsModel.spaceToSpin);
            Services.storage.set(Settings.QUICK_SPIN, this.settingsModel.quickSpin);
        }
    }

    private updateTurbo() {
        stateMachine.turbo = this.settingsModel.turboSpin;
    }
}
